<template>
    <div class="ath-table-row-stencil f fh fj-sb fa-c pr dw-10"
        :class="[isEven ? 'ath-row-even' : '']">
        <div v-for="column in columns"
            class="ath-table-cell dh-10 sp-l-s f fh fa-c"
            :style="{'width': column.width_rem + 'rem'}"
            :class="[column.locked ? 'ath-lock-column' : '', column.text_classes]"
            :key="column.key">
            <span class="el-stencil el--t-txt"></span>
        </div>
    </div>
</template>
<script>

export default {
    name: 'mead-table-row-stencil',
    props: {
        /**
         * The column definitions used to size each placeholder cell (width, lock state, text
         * classes) to match the real table's layout while loading.
         */
        columns   : {type: Array, default: () => []},
        /**
         * The stencil row's position in the table, used to alternate even/odd row styling.
         */
        index   : {type: Number, default: 0},
    },
    computed: {
        isEven: function () {
            return this.index % 2 === 0;
        },
    },
};
</script>
<style lang="scss" scoped>
.ath-table-row-stencil {
    height: 5rem;
}

.el-stencil {
    width: 6rem;
}
</style>